import Api from '../utilities/api';
import {
  triggerIdA, triggerIdU
} from './apiConfig';
import TriskeleScreens from './TriskeleScreens';

export default class AdminAccess {
  static getCurrentUserRole = () => Api.post('_Admin_CurrentUserRole', {
    params: [
      {
        name: 'ScrnId',
        value: TriskeleScreens.adminAccess.ScreenId
      },
      {
        name: 'TrggrId',
        value: triggerIdA
      },
      {
        name: 'BuildfireID',
        value: "D"
      }
    ]
  })

  static getUsersList = () => Api.post('_Admin_UsersList', {
    params: [
      {
        name: 'ScrnId',
        value: TriskeleScreens.adminUsers.ScreenId
      },
      {
        name: 'TrggrId',
        value: triggerIdA
      },
      {
        name: 'BuildfireID',
        value: "D"
      }
    ]
  })

  static searchUsers = (searchTerm) => Api.post('_Admin_UserSearch', {
    params: [
      {
        name: 'ScrnId',
        value: TriskeleScreens.adminUsers.ScreenId
      },
      {
        name: 'TrggrId',
        value: triggerIdA
      },
      {
        name: 'BuildfireID',
        value: "D"
      },
      {
        name: 'SearchTerm',
        value: searchTerm || 'NA'
      }
    ]
  })

  static grantAdmin = ({
    targetApiUserId, email, firstName, lastName, preferredName = 'NA'
  }) => Api.post('_Admin_GrantAdmin', {
    params: [
      {
        name: 'ScrnId',
        value: TriskeleScreens.adminUsers.ScreenId
      },
      {
        name: 'TrggrId',
        value: triggerIdU
      },
      {
        name: 'BuildfireID',
        value: "D"
      },
      {
        name: 'TargetAPIUserID',
        value: targetApiUserId
      },
      {
        name: 'Email',
        value: email
      },
      {
        name: 'FirstName',
        value: firstName
      },
      {
        name: 'LastName',
        value: lastName
      },
      {
        name: 'PreferredName',
        value: preferredName || 'NA'
      }
    ]
  })

  static revokeAdmin = (targetApiUserId) => Api.post('_Admin_RevokeAdmin', {
    params: [
      {
        name: 'ScrnId',
        value: TriskeleScreens.adminUsers.ScreenId
      },
      {
        name: 'TrggrId',
        value: triggerIdU
      },
      {
        name: 'BuildfireID',
        value: "D"
      },
      {
        name: 'TargetAPIUserID',
        value: targetApiUserId
      }
    ]
  })

  static getActivityLog = ({
    dateFrom = 'NA', dateTo = 'NA', targetUserId = 'NA', procedureName = 'NA'
  } = {}) => Api.post('_Admin_ActivityLog', {
    params: [
      {
        name: 'ScrnId',
        value: TriskeleScreens.adminActivity.ScreenId
      },
      {
        name: 'TrggrId',
        value: triggerIdA
      },
      {
        name: 'BuildfireID',
        value: "D"
      },
      {
        name: 'DateFrom',
        value: dateFrom || 'NA'
      },
      {
        name: 'DateTo',
        value: dateTo || 'NA'
      },
      {
        name: 'TargetUserID',
        value: targetUserId || 'NA'
      },
      {
        name: 'ProcedureName',
        value: procedureName || 'NA'
      }
    ]
  })

  static getDashboardSummary = (dateFrom, dateTo) => Api.post('_Admin_DashboardSummary', {
    params: [
      {
        name: 'ScrnId',
        value: TriskeleScreens.adminDashboard.ScreenId
      },
      {
        name: 'TrggrId',
        value: triggerIdA
      },
      {
        name: 'BuildfireID',
        value: "D"
      },
      {
        name: 'DateFrom',
        value: dateFrom
      },
      {
        name: 'DateTo',
        value: dateTo
      }
    ]
  })

  static getDashboardSeries = (dateFrom, dateTo) => Api.post('_Admin_DashboardSeries', {
    params: [
      {
        name: 'ScrnId',
        value: TriskeleScreens.adminDashboard.ScreenId
      },
      {
        name: 'TrggrId',
        value: triggerIdA
      },
      {
        name: 'BuildfireID',
        value: "D"
      },
      {
        name: 'DateFrom',
        value: dateFrom
      },
      {
        name: 'DateTo',
        value: dateTo
      }
    ]
  })

  static getDashboardIntakeBreakdown = (dateFrom, dateTo) => Api.post('_Admin_DashboardIntakeBreakdown', {
    params: [
      {
        name: 'ScrnId',
        value: TriskeleScreens.adminDashboard.ScreenId
      },
      {
        name: 'TrggrId',
        value: triggerIdA
      },
      {
        name: 'BuildfireID',
        value: "D"
      },
      {
        name: 'DateFrom',
        value: dateFrom
      },
      {
        name: 'DateTo',
        value: dateTo
      }
    ]
  })
}
